globalThis.appVisitor = globalThis.appVisitor || {};
appVisitor.blog = appVisitor.blog || {};

appVisitor.blog.shareEventsController = (function() {
  function ShareEventsController($html) {
    this.$html = $html;
  }

  ShareEventsController.prototype = {
    init: function () {
      ShareEvents.initEvents(this.$html);
      this.initEvents();
    },
    initEvents: function() {
      $(document).on('clipboard.success', function(e, $trigger) {
        if(!$trigger.data('ui-tooltip')) $trigger.tooltip({tooltipClass: 'sb-vi-tooltip-bottom sb-vi-tooltip-box'});
        $trigger.prop('title', 'Copié !').tooltip('open').trigger('mouseenter');
      }).on('clipboard.error', function() {
        if(!$trigger.data('ui-tooltip')) $trigger.tooltip({tooltipClass: 'sb-vi-tooltip-bottom sb-vi-tooltip-box'});
        $trigger.prop('title', 'Erreur lors de la copie...').tooltip('open').trigger('mouseenter');
      });
    }
  }

  return ShareEventsController;
})();
